import { useId } from 'react';

// Stand-in for Figma "Any kind of game" — replace with the design export when it lands.
export default function GameTypeAny({ className }: { className?: string }) {
  const id = `game-type-any-${useId().replace(/:/g, '')}`;

  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="7.4" fill={`url(#${id}-ball)`} />
      <circle cx="10" cy="10" r="7.4" fill={`url(#${id}-shade)`} />
      <g stroke={`url(#${id}-seam)`} strokeWidth="1.25" strokeLinecap="round" fill="none">
        <path d="M3.45 5.3C6.1 7.55 6.1 12.45 3.45 14.7" />
        <path d="M16.55 5.3C13.9 7.55 13.9 12.45 16.55 14.7" />
      </g>
      <defs>
        <radialGradient
          id={`${id}-ball`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.2 5.6) rotate(52) scale(15.4)"
        >
          <stop stopColor="#E2FA6B" />
          <stop offset="0.52" stopColor="#C2E732" />
          <stop offset="1" stopColor="#8FB814" />
        </radialGradient>
        <radialGradient
          id={`${id}-shade`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10 2.4) rotate(90) scale(17.6 19.2)"
        >
          <stop offset="0.74" stopColor="#A8CF26" stopOpacity="0" />
          <stop offset="1" stopColor="#6F9A2A" />
        </radialGradient>
        <linearGradient
          id={`${id}-seam`}
          x1="10"
          y1="4.2"
          x2="10"
          y2="15.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFEF4" />
          <stop offset="1" stopColor="#F0EDD4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
